/**
 * Arabic for the contact directory, Who is told, and the messages sent about
 * a work order. Proposed; pending native review.
 */
const ar: Record<string, string> = {
  "Contact directory": "دليل جهات الاتصال",
  "Who is told": "من يُبلَّغ",
  "Every stakeholder and contractor — contractors, agencies, airlines, in-house departments — the people in each, and every way to reach them: several mobiles, landlines, several emails and WhatsApp, each labelled, one of each kind primary, each switched on or off for messages, and whether they get alerts in the mobile app.":
    "كل جهة معنية ومقاول — المقاولون والجهات الحكومية وشركات الطيران والإدارات الداخلية — والأشخاص في كل منها، وكل وسيلة للوصول إليهم: عدة جوالات وهواتف ثابتة وعدة عناوين بريد وواتساب، لكلٍّ منها وصف، وواحدة رئيسية من كل نوع، ويمكن تفعيل كلٍّ منها أو إيقافه للرسائل، ومن يتلقى التنبيهات في تطبيق الجوال.",
  "The rules that send work orders out by SMS, email and the mobile app: which events (raised, dispatched, completed, overdue …), which work (priority, kind, zone, team), who is told and how, and who is told if nobody starts the work in time — each rule showing who it actually reaches, at which numbers and addresses.":
    "القواعد التي ترسل أوامر العمل بالرسائل النصية والبريد وتطبيق الجوال: أي الأحداث (فُتح، أُرسل، اكتمل، تأخر …)، وأي الأعمال (الأولوية والنوع والمنطقة والفريق)، ومن يُبلَّغ وكيف، ومن يُبلَّغ إذا لم يبدأ أحد العمل في الوقت — وكل قاعدة تُظهر من تصل إليه فعلاً وعلى أي أرقام وعناوين.",
  "Add a number or address": "إضافة رقم أو عنوان",
  "Add an organization": "إضافة جهة",
  "Every stakeholder and contractor, the people in each, and every way to reach them. Work order messages go out from here — by SMS, email and the mobile app — to whoever the rules on Who is told name.":
    "كل جهة معنية ومقاول، والأشخاص في كل منها، وكل وسيلة للوصول إليهم. تُرسل رسائل أوامر العمل من هنا — بالرسائل النصية والبريد وتطبيق الجوال — إلى من تسمّيهم قواعد «من يُبلَّغ».",
  Label: "الوصف",
  "Mobile app sign-in": "حساب تطبيق الجوال",
  "Nobody listed yet.": "لا أحد مسجّل بعد.",
  "Number or address": "الرقم أو العنوان",
  "Numbers and addresses": "الأرقام والعناوين",
  Primary: "رئيسي",
  "SMS and email are not set up to send yet: messages are recorded on each work order and wait until a provider is connected.":
    "لم تُضبط الرسائل النصية والبريد للإرسال بعد: تُسجَّل الرسائل على كل أمر عمل وتنتظر حتى يُربط مزوّد الخدمة.",
  "Search the directory": "البحث في الدليل",
  "Who is told about P1 work?": "من يُبلَّغ عن أعمال P1؟",
  "Who is told →": "من يُبلَّغ ←",
  "e.g. 24/7, Sun–Thu 07:00–16:00": "مثل 24/7، الأحد–الخميس 07:00–16:00",
  "every one switched on gets the message; one of each kind is primary":
    "كل وسيلة مفعّلة تصلها الرسالة؛ وواحدة من كل نوع رئيسية",
  "label — duty phone, office …": "الوصف — هاتف المناوبة، المكتب …",
  "messages go here": "تصل الرسائل إلى هنا",
  messages: "الرسائل",
  "mobile app": "تطبيق الجوال",
  "no number or address": "لا رقم ولا عنوان",
  "prefers {c}": "يفضّل {c}",
  "primary of its kind": "الرئيسي من نوعه",
  retired: "متوقف",
  "search a name, a number, an address": "ابحث عن اسم أو رقم أو عنوان",
  "switched off for messages": "موقوف عن الرسائل",
  "{o} organizations · {p} people · {n} numbers and addresses": "{o} جهات · {p} أشخاص · {n} أرقام وعناوين",
  "{o} organizations, {p} people, {n} ways to reach them.": "{o} جهات، {p} أشخاص، {n} وسيلة للوصول إليهم.",
  "{site} · Platform": "{site} · المنصة",
  "— none —": "— لا شيء —",
  "— not signed in to the app —": "— غير مسجّل في التطبيق —",
  "Add a rule": "إضافة قاعدة",
  "Contact directory →": "دليل جهات الاتصال ←",
  "Dispatch teams": "فرق الإرسال",
  "Edit the rule": "تعديل القاعدة",
  "If nobody starts it in time, tell someone else": "إذا لم يبدأه أحد في الوقت، أبلغ شخصاً آخر",
  "If nobody starts it within {m} minutes, tell {who}.": "إذا لم يبدأه أحد خلال {m} دقيقة، أبلغ {who}.",
  "No rules yet — nobody is told about work orders except the teams dispatched from the map.":
    "لا قواعد بعد — لا يُبلَّغ أحد عن أوامر العمل إلا الفرق المُرسلة من الخريطة.",
  "Nothing chosen under Which work means every work order.": "عدم اختيار شيء تحت «أي الأعمال» يعني كل أوامر العمل.",
  "Organizations — everyone in them": "الجهات — كل من فيها",
  "Rule name": "اسم القاعدة",
  Tell: "أبلغ",
  "The rules that send work orders out by SMS, email and the mobile app. The people come from the contact directory; every number and address switched on there is used.":
    "القواعد التي ترسل أوامر العمل بالرسائل النصية والبريد وتطبيق الجوال. يأتي الأشخاص من دليل جهات الاتصال؛ ويُستخدم كل رقم وعنوان مفعّل فيه.",
  "When {what} work is {events}, tell {who} by {how}.": "عندما يكون عمل {what} {events}، أبلغ {who} عبر {how}.",
  "Which work": "أي الأعمال",
  any: "أي",
  "e.g. Lighting faults — the AGL contractor": "مثل أعطال الإنارة — مقاول الإنارة الأرضية",
  "in {zones}": "في {zones}",
  "no email": "لا بريد",
  "no mobile": "لا جوال",
  "not on the app": "ليس على التطبيق",
  on: "مفعّلة",
  "sent to {teams}": "مُرسل إلى {teams}",
  "switched off": "موقوفة",
  "team {name}": "الفريق {name}",
  "{n} rules decide who is told about which work.": "{n} قواعد تحدد من يُبلَّغ عن أي عمل.",
  "Nobody has been messaged about this work order.": "لم تُرسل رسالة لأحد عن أمر العمل هذا.",
  dispatch: "إرسال",
  "rule: {r}": "القاعدة: {r}",
  "who was told about this work order, and how it went": "من أُبلغ عن أمر العمل هذا، وكيف جرى ذلك",
  "{n} messages to {p} people by SMS, email and the mobile app":
    "{n} رسائل إلى {p} أشخاص بالرسائل النصية والبريد وتطبيق الجوال",
  Agency: "جهة",
  Authority: "جهة حكومية",
  Landline: "هاتف ثابت",
  WhatsApp: "واتساب",
  Escalated: "صُعّد",
  "Mobile app": "تطبيق الجوال",
  queued: "في الانتظار",
  sent: "أُرسلت",
  "nothing on file": "لا شيء مسجّل",
  "waiting for a provider": "بانتظار مزوّد الخدمة",
  "waiting for the app": "بانتظار التطبيق",
  read: "قُرئت",
  "Not in an organisation": "خارج أي جهة",
  Organisation: "الجهة",
  Prefers: "يفضّل",
  "Zones (codes, comma separated; a code covers everything that starts with it)":
    "المناطق (رموز مفصولة بفواصل؛ الرمز يشمل كل ما يبدأ به)",
  "Within (minutes)": "خلال (دقائق)",
  Events: "الأحداث",
  Priorities: "الأولويات",
  Kinds: "الأنواع",
  "Dispatched to": "مُرسل إلى",
  Channels: "القنوات",
  Recipients: "المستلمون",
  "Escalate to": "التصعيد إلى",
  corrective: "تصحيحي",
  preventive: "وقائي",
  "out of scope": "خارج النطاق",
};

export default ar;
